import axios from "axios";

const insert = async (url, data) => {
  const { data: result } = await axios.post(url, data);
  return result;
};

export default insert;
